import { cn } from 'lib/utils';
import { Button } from './button';

type PaginationControlsProps = {
  page: number;
  pageSize: number;
  totalCount: number;
  onPageChange: (page: number) => void;
  className?: string;
};

export function PaginationControls({
  page,
  pageSize,
  totalCount,
  onPageChange,
  className,
}: PaginationControlsProps) {
  const totalPages = Math.max(1, Math.ceil(totalCount / pageSize));
  const startItem = totalCount === 0 ? 0 : (page - 1) * pageSize + 1;
  const endItem = totalCount === 0 ? 0 : Math.min(totalCount, page * pageSize);

  const handlePrevious = () => {
    onPageChange(Math.max(1, page - 1));
  };

  const handleNext = () => {
    onPageChange(Math.min(totalPages, page + 1));
  };

  return (
    <div
      className={cn(
        'flex flex-wrap items-center justify-between gap-3 rounded-lg border border-border/40 bg-white/5 px-3 py-2 text-sm',
        className,
      )}
    >
      <span className="text-muted-foreground">
        Showing {startItem}-{endItem} of {totalCount}
      </span>
      <div className="flex items-center gap-2">
        <Button variant="ghost" size="auto" onClick={handlePrevious} disabled={page <= 1}>
          Previous
        </Button>
        <span className="text-muted-foreground">
          Page {totalCount === 0 ? 0 : page} of {totalCount === 0 ? 0 : totalPages}
        </span>
        <Button
          variant="ghost"
          size="auto"
          onClick={handleNext}
          disabled={page >= totalPages || totalCount === 0}
        >
          Next
        </Button>
      </div>
    </div>
  );
}
